import { ExternalLink } from 'lucide-react';
import { useI18n } from '@/i18n';

export const HostedCheckoutNotice=({checkout,id})=>{
  const {tx}=useI18n();
  if(!checkout.link&&!checkout.error)return null;
  return <div className="booking-checkout-notice" data-testid={`${id}-checkout-notice`} role="status">
    {checkout.error&&<p data-testid={`${id}-checkout-error`}>{checkout.error==='The payment link is unavailable. Please try again.'?tx('The payment link is unavailable. Please try again.'):tx('Please review your consent before opening payment.')}</p>}
    {checkout.link&&<>
      <p>{tx('Payment opens in a separate secure window. If it did not open, use the button below.')}</p>
      <button type="button" data-testid={`${id}-open-checkout`} disabled={!checkout.canOpen} onClick={checkout.reopen}>
        <ExternalLink size={16}/>{tx('Open secure payment')}
      </button>
    </>}
  </div>;
};